export const ELI_SETTINGS_TABS = {
	SETTINGS: 'settings',
	USAGE: 'usage',
} as const;

export type EliSettingsTab =
	(typeof ELI_SETTINGS_TABS)[keyof typeof ELI_SETTINGS_TABS];

export const ELI_SETTINGS_ROUTE_NAMES = {
	SETTINGS: 'eli-settings-settings',
	USAGE: 'eli-settings-usage',
} as const;

export const ELI_SETTINGS_PATHS = {
	SETTINGS: '/settings/eli',
	USAGE: '/settings/eli/usage',
} as const;
